import { ACCEPT_COOKIES_POLICY } from "../../../actionTypes";

export const acceptCookyPolicy = () => {
	return {
		type: ACCEPT_COOKIES_POLICY,
	};
};
